
import Vuex from 'vuex'
import Vue from "vue";
const axios = require('axios');
import router from "./router/index.js";
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    connected: false,
    isLock: false,
    apiUrl: process.env.VUE_APP_API_URL,
    userRole: -1,
    loaded: false
  },
  getters: {
    // Rôles "privilégiés" ayant accès aux fonctions d'administration :
    // Administrateur (1024), Responsable (324), Coresponsable (68).
    // Source unique de vérité — à utiliser partout plutôt que des
    // comparaisons numériques en dur (qui avaient divergé entre composants).
    isManager(state) {
      return [68, 324, 1024].includes(Number(state.userRole));
    }
  },
  mutations: {
    data(state) {
      return {
        state,
      }
    },
    created: function (state) {
      // La session est désormais portée par le cookie httpOnly (plus aucun mot
      // de passe stocké côté client). Au chargement, on restaure l'état
      // d'affichage depuis localStorage. Si la session serveur a expiré, la
      // première requête protégée renverra 401 et l'intercepteur axios
      // (main.js) redirigera vers la page de connexion.
      try {
        if (localStorage.login && localStorage.id && localStorage.role) {
          state.userRole = Number(localStorage.role);
          store.commit('setRole', Number(localStorage.role));
          store.commit('setConnected', true);
          state.connected = true;
        }
        state.loaded = true;
      } catch (error) {
        state.loaded = true;
        router.push({ name: 'Connection' });
      }
    },
    setIsLock(state, value) {
      state.isLock = value;
    },
    setRole(state, value) {
      if (value) {
        state.userRole = value;
      }
    },
    setConnected(state, newValue) {
      if (this.debug) {
        console.log('setMessageAction triggered with', newValue)
      }
      state.connected = newValue;
    },
    clearConnected(state) {
      if (this.debug) {
        console.log('clearMessageAction triggered')
      }
      state.connected = false;
      localStorage.clear();
    },
  }
})
export default store;